import { useState } from "react";
import "../form/form.css";
import { Col, Form, Row } from "react-bootstrap";
import Button from "@/components/common/buttons/Button";
import facebookIcon from "@/assets/facebook.png";
import instagramIcon from "@/assets/instagram.png";
import whatsappIcon from "@/assets/whatsapp.png";

const CCshopAdminRequestForm = () => {
  const [formData, setFormData] = useState({
	name: '',
	email: '',
	role: '',
	brand: '',
	website: '',
	budget: '',
	message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
	setFormData({
	  ...formData,
	  [e.target.name]: e.target.value
	});
  };

  const validateForm = () => {
	const requiredFields = [
	  { field: 'name', label: 'Nume Prenume' },
	  { field: 'email', label: 'Email' },
	  { field: 'role', label: 'În calitate de' },
	  { field: 'brand', label: 'Brand actual' },
	  { field: 'website', label: 'Website' },
	  { field: 'budget', label: 'Buget marketing lunar' }
	];

	const missingFields = requiredFields.filter(item => !formData[item.field as keyof typeof formData]);
	
	if (missingFields.length > 0) {
	  const fieldNames = missingFields.map(item => item.label).join(', ');
	  alert(`Te rugăm completează următoarele câmpuri: ${fieldNames}`);
	  return false;
	}
	return true;
  };

  const handleSubmit = async (e?: React.FormEvent) => {
	// Only call preventDefault if we have a real form event
	if (e && e.preventDefault) {
	  e.preventDefault();
	}
	
	if (!validateForm()) {
	  return;
	}

	setIsSubmitting(true);

	try {
	  const response = await fetch('https://pixado.ro/api/send-email.php', {
		method: 'POST',
		headers: {
		  'Content-Type': 'application/json',
		},
		body: JSON.stringify(formData)
	  });
	  
	  const result = await response.json();
	  
	  if (result.success) {
		alert('Cererea a fost trimisă cu succes! Vei primi un răspuns în maxim 48 de ore.');
		setFormData({
		  name: '', email: '', role: '', brand: '', website: '', budget: '', message: ''
		});
	  } else {
		alert('A apărut o eroare. Te rugăm încearcă din nou.');
	  }
	} catch (error) {
	  console.error('Error:', error);
	  alert('A apărut o eroare. Te rugăm încearcă din nou.');
	} finally {
	  setIsSubmitting(false);
	}
  };

  return (
	<>
	  <Form className="contact-form" onSubmit={handleSubmit}>
		<Row className="contact-row">
		  <Col xs={12} lg={6}>
			<Form.Group className="input-wrapper-left">
			  <Form.Control
				type="text"
				name="name"
				value={formData.name}
				onChange={handleChange}
				className="body contact-input"
				placeholder="Nume Prenume *"
				required
			  />
			</Form.Group>
		  </Col>
		  <Col xs={12} lg={6}>
			<Form.Group className="input-wrapper-right">
			  <Form.Control
				type="email"
				name="email"
				value={formData.email}
				onChange={handleChange}
				className="body contact-input"
				placeholder="Adresa de email *"
				required
			  />
			</Form.Group>
		  </Col>
		</Row>
		<Row className="contact-row">
		  <Col xs={12} lg={6}>
			<Form.Group className="input-wrapper-left">
			  <Form.Select
				name="role"
				value={formData.role}
				onChange={handleChange}
				className="body contact-input"
				required
			  >
				<option value="" disabled>În calitate de *</option>
				<option value="owner">(Potential) Owner Shop</option>
				<option value="marketer">Marketer</option>
			  </Form.Select>
			</Form.Group>
		  </Col>
		  <Col xs={12} lg={6}>
			<Form.Group className="input-wrapper-right">
			  <Form.Control
				type="text"
				name="brand"
				value={formData.brand}
				onChange={handleChange}
				className="body contact-input"
				placeholder="Brand actual *"
				required
			  />
			</Form.Group>
		  </Col>
		</Row>
		<Row className="contact-row">
		  <Col xs={12} lg={6}>
			<Form.Group className="input-wrapper-left">
			  <Form.Control
				type="text"
				name="website"
				value={formData.website}
				onChange={handleChange}
				className="body contact-input"
				placeholder="Website *"
				required
			  />
			</Form.Group>
		  </Col>
		  <Col xs={12} lg={6}>
			<Form.Group className="input-wrapper-right">
			  <Form.Select
				name="budget"
				value={formData.budget}
				onChange={handleChange}
				className="body contact-input"
				required
			  >
				<option value="" disabled>Buget marketing lunar *</option>
				<option value="nu-se-aplica">Nu se aplică</option>
				<option value="500-1000">€500 - €1.000</option>
				<option value="1000-2500">€1.000 - €2.500</option>
				<option value="2500-5000">€2.500 - €5.000</option>
				<option value="5000-10000">€5.000 - €10.000</option>
				<option value="10000+">€10.000+</option>
			  </Form.Select>
			</Form.Group>
		  </Col>
		</Row>
		<Row className="contact-row">
		  <Col xs={12}>
			<Form.Group>
			  <Form.Control
				as="textarea"
				name="message"
				value={formData.message}
				onChange={handleChange}
				className="contact-textarea body contact-input"
				placeholder="Detalii despre proiectul de e-commerce (opțional)"
			  />
			</Form.Group>
		  </Col>
		</Row>
	  </Form>
	  <Row className="contact-submit-row">
		<Col xs={12} lg={6}>
		  <Button 
			className="contact-button" 
			text={isSubmitting ? "Se trimite..." : "Solicită acces admin"}
			onClick={() => handleSubmit()}
		  />
		</Col>
		<Col className="submit-second-col" xs={12} lg={{ span: 4, offset: 2 }}>
		  <Row className="body">Hai cu noi pe social media!</Row>
		  <Row>
			<Col xs={4}>
			  <a href="https://www.facebook.com/pixadoagency" target="_blank" rel="noopener noreferrer">
				<img src={facebookIcon} className="contact-dot" alt="Facebook" />
			  </a>
			</Col>
			<Col xs={4}>
			  <a href="https://www.instagram.com/pixadoagency/" target="_blank" rel="noopener noreferrer">
				<img src={instagramIcon} className="contact-dot" alt="Instagram" />
			  </a>
			</Col>
			<Col xs={4}>
			  <a href="https://wa.me/40745371620" target="_blank" rel="noopener noreferrer">
				<img src={whatsappIcon} className="contact-dot" alt="WhatsApp" />
			  </a>
			</Col>
		  </Row>
		</Col>
	  </Row>
	</>
  );
};

export default CCshopAdminRequestForm;